import { createContext, useContext } from "react";

export const FilterSlotContext = createContext<HTMLElement | null>(null);

export const useFilterSlot = (): HTMLElement | null =>
    useContext(FilterSlotContext);
